import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-motto',
  templateUrl: './motto.component.html',
  styleUrls: ['./motto.component.css']
})
export class MottoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
